/* The same in-frame 2.5x pointer magnifier as Under Improvement. */
// The toggle is a small round button: a magnifier with a plus to open the zoom,
// with a minus to close it. Its name stays available to screen readers.
const ZOOM_ICONS = `<svg class='product-zoom__icon product-zoom__icon--in' viewBox='0 0 24 24' aria-hidden='true' focusable='false'><circle cx='10' cy='10' r='6.5'/><path d='m14.8 14.8 5.7 5.7M10 7v6M7 10h6'/></svg><svg class='product-zoom__icon product-zoom__icon--out' viewBox='0 0 24 24' aria-hidden='true' focusable='false'><circle cx='10' cy='10' r='6.5'/><path d='m14.8 14.8 5.7 5.7M7 10h6'/></svg>`;
function bindProductZoom(root = document) {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = (value) => Math.min(1, Math.max(0, value));
  root.querySelectorAll('[data-product-zoom]').forEach((figure) => {
    if (figure.dataset.zoomBound) return;
    const base = figure.querySelector('img');
    if (!base) return;
    figure.dataset.zoomBound = 'true';
    const layer = document.createElement('div');
    layer.className = 'product-zoom';
    layer.setAttribute('aria-hidden', 'true');
    const image = document.createElement('div');
    image.className = 'product-zoom__image';
    layer.append(image);
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'product-zoom__toggle';
    button.setAttribute('aria-pressed', 'false');
    button.title = 'Zoom image. Use arrow keys to move; Escape to close.';
    button.innerHTML = ZOOM_ICONS;
    const name = (open) => {
      button.setAttribute('aria-label', open ? 'Close zoom' : 'Zoom image');
      button.dataset.zoomState = open ? 'open' : 'closed';
    };
    name(false);
    figure.append(layer, button);
    let active = false;
    let pinned = false;
    let pointerInside = false;
    let hoverBlocked = false;
    let frame = 0;
    let last = 0;
    let scale = 1;
    let generation = 0;
    let loadedSource = '';
    let touch = null;
    const pointer = { x: 0.5, y: 0.5 };
    const shown = { x: 0.5, y: 0.5 };

    function ensurePicture() {
      const source = base.getAttribute('src');
      if (!source || loadedSource === source) return;
      loadedSource = source;
      const ticket = ++generation;
      const fit = getComputedStyle(base);
      image.style.backgroundSize = fit.objectFit === 'contain' ? 'contain' : 'cover';
      image.style.backgroundPosition = fit.objectPosition;
      // Shopify limits image_url transforms to the original image dimensions.
      const sharp = new URL(source, document.baseURI);
      sharp.searchParams.set('width', '2000');
      const paint = async (src) => {
        const picture = new Image();
        picture.src = src;
        await picture.decode();
        if (ticket !== generation || base.getAttribute('src') !== source) return;
        image.style.backgroundImage = `url("${picture.src.replace(/["\\]/g, '\\$&')}")`;
        layer.dataset.ready = '';
      };
      // Never paint the preceding color's currentSrc while the new image loads.
      paint(source)
        .catch(() => {})
        .then(() => (ticket === generation ? paint(sharp.href) : undefined))
        .catch(() => {});
    }
    function track(event) {
      const box = figure.getBoundingClientRect();
      pointer.x = clamp((event.clientX - box.left) / box.width);
      pointer.y = clamp((event.clientY - box.top) / box.height);
    }
    function render(now) {
      if (!figure.isConnected) return reset();
      const elapsed = last ? Math.min(now - last, 64) : 16;
      last = now;
      const still = reducedMotion.matches;
      const follow = still ? 1 : 1 - Math.exp(-elapsed / 60);
      const grow = still ? 1 : 1 - Math.exp(-elapsed / (active ? 90 : 70));
      const target = active ? 2.5 : 1;
      scale += (target - scale) * grow;
      shown.x += (pointer.x - shown.x) * follow;
      shown.y += (pointer.y - shown.y) * follow;
      const settled =
        Math.abs(target - scale) < 0.002 &&
        Math.abs(pointer.x - shown.x) < 0.0005 &&
        Math.abs(pointer.y - shown.y) < 0.0005;
      if (settled) {
        scale = target;
        shown.x = pointer.x;
        shown.y = pointer.y;
      }
      image.style.transform = `translate3d(${-shown.x * (scale - 1) * layer.clientWidth}px, ${-shown.y * (scale - 1) * layer.clientHeight}px, 0) scale(${scale})`;
      if (settled) {
        frame = 0;
        last = 0;
        if (!active) figure.classList.remove('is-zooming');
      } else frame = requestAnimationFrame(render);
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(render);
    }
    function setActive(value) {
      active = value;
      // The control describes explicit touch/keyboard zoom, never hover state.
      button.setAttribute('aria-pressed', String(pinned && active));
      name(pinned && active);
      figure.classList.toggle('is-zoom-pinned', pinned && active);
      if (active) {
        ensurePicture();
        if (!figure.classList.contains('is-zooming')) Object.assign(shown, pointer);
        figure.classList.add('is-zooming');
      }
      schedule();
    }
    function close() {
      hoverBlocked = pointerInside || figure.classList.contains('has-zoom-touch');
      pinned = false;
      touch = null;
      setActive(false);
      // Explicit close must restore the base image immediately, even mid-hover.
      cancelAnimationFrame(frame);
      frame = last = 0;
      scale = 1;
      image.style.transform = '';
      figure.classList.remove('is-zooming');
    }
    function reset() {
      cancelAnimationFrame(frame);
      frame = last = 0;
      active = pinned = false;
      hoverBlocked = pointerInside || figure.classList.contains('has-zoom-touch');
      touch = null;
      scale = 1;
      generation++;
      loadedSource = '';
      delete layer.dataset.ready;
      image.style.backgroundImage = '';
      image.style.transform = '';
      Object.assign(pointer, { x: 0.5, y: 0.5 });
      Object.assign(shown, pointer);
      figure.classList.remove('is-zooming', 'is-zoom-pinned');
      button.setAttribute('aria-pressed', 'false');
      name(false);
    }
    figure.addEventListener('pointerenter', (event) => {
      figure.classList.toggle('has-zoom-touch', event.pointerType === 'touch');
      if (event.pointerType === 'touch') return;
      pointerInside = true;
      if (pinned || hoverBlocked) return;
      track(event);
      setActive(true);
    });
    figure.addEventListener('pointermove', (event) => {
      if (!active || event.target.closest('.product-zoom__toggle')) return;
      if (event.pointerType === 'touch') {
        if (!touch || touch.id !== event.pointerId) return;
        const box = figure.getBoundingClientRect();
        pointer.x = clamp(touch.x - (event.clientX - touch.clientX) / (1.5 * box.width));
        pointer.y = clamp(touch.y - (event.clientY - touch.clientY) / (1.5 * box.height));
      } else track(event);
      schedule();
    });
    figure.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'touch') return;
      pointerInside = false;
      hoverBlocked = false;
      if (!pinned && active) setActive(false);
    });
    figure.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch') figure.classList.add('has-zoom-touch');
      if (event.pointerType !== 'touch' || !pinned || event.target.closest('button')) return;
      touch = { id: event.pointerId, clientX: event.clientX, clientY: event.clientY, ...pointer };
      figure.setPointerCapture(event.pointerId);
    });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((name) => {
      figure.addEventListener(name, () => (touch = null));
    });
    button.addEventListener('click', () => {
      if (active) return close();
      pinned = true;
      Object.assign(pointer, { x: 0.5, y: 0.5 });
      setActive(true);
    });
    button.addEventListener('keydown', (event) => {
      const moves = { ArrowLeft: [-0.1, 0], ArrowRight: [0.1, 0], ArrowUp: [0, -0.1], ArrowDown: [0, 0.1] };
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        close();
      } else if (active && moves[event.key]) {
        event.preventDefault();
        event.stopPropagation();
        pointer.x = clamp(pointer.x + moves[event.key][0]);
        pointer.y = clamp(pointer.y + moves[event.key][1]);
        schedule();
      }
    });
    button.addEventListener('focus', () => {
      if (active && !pinned) close();
    });
    button.addEventListener('blur', (event) => {
      if (event.relatedTarget && !figure.contains(event.relatedTarget)) {
        close();
      }
    });
    const escape = (event) => {
      if (event.key === 'Escape' && active) {
        event.preventDefault();
        close();
      }
    };
    document.addEventListener('keydown', escape);
    const observer = new MutationObserver((records) => {
      if (
        records.some(
          ({ target, attributeName, oldValue }) =>
            (target === base && oldValue !== base.getAttribute(attributeName)) ||
            (target.contains(figure) &&
              (attributeName === 'hidden' ||
                (target.matches('[data-gallery-slide]') &&
                  (oldValue ?? '').split(/\s+/).includes('is-active') !== target.classList.contains('is-active')))),
        )
      )
        reset();
    });
    const gallery = figure.closest('.packet-gallery');
    observer.observe(gallery, {
      subtree: true,
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['src', 'srcset', 'hidden', 'class'],
    });
    // Theme editor removals must release observers and any animation loop.
    figure.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      reset();
      observer.disconnect();
      document.removeEventListener('keydown', escape);
    });
  });
}

bindProductZoom();
document.addEventListener('shopify:section:load', (event) => bindProductZoom(event.target));
